"use client";

import React from "react";
import Icon from "../../common/components/Icon";
import Button from "./Button";
import { useTranslations } from "next-intl";
import FilterResetButton from "./FilterResetButton";
export interface FilterWrapperProps {
  children?: React.ReactNode;
  modalRouteHref: string;
}

const FilterWrapper: React.FC<FilterWrapperProps> = ({
  modalRouteHref,
  children,
}) => {
  const t = useTranslations();
  return (
    <div
      className="overflow-y-auto h-100 py-lg-1"
      style={{ overscrollBehavior: "contain" }}
    >
      <div className="visible-on-desktop search-filter-area">
        {children}
        <FilterResetButton />
      </div>

      <div className="visible-on-mobile w-100">
        <Button appearance="input" href={modalRouteHref}>
          <Icon icon="filter-list" />
          {t("refine_filter")}
        </Button>
      </div>
    </div>
  );
};

export default FilterWrapper;
